import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchIpaSymbolById } from "./ipaService";
import "./IpaPage.css";

const difficultyColor = (d) => {
  const map = { BEGINNER: "#4caf50", INTERMEDIATE: "#ff9800", ADVANCED: "#e91e63" };
  return map[d?.toUpperCase()] || "#999";
};

const IpaSymbolDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [symbol, setSymbol] = useState(null);
  const [loading, setLoading] = useState(true);
  const audioRef = useRef(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const res = await fetchIpaSymbolById(id);
      if (res.status === 200 && res.data?.status) {
        setSymbol(res.data.data);
      }
      setLoading(false);
    };
    load();
  }, [id]);

  const playAudio = () => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play();
    }
  };

  if (loading) {
    return (<><Navbar /><div className="ipa-detail"><p className="ipa-detail-loading">Loading...</p></div><Footer /></>);
  }

  if (!symbol) {
    return (
      <><Navbar />
        <div className="ipa-detail">
          <p className="ipa-detail-not-found">Symbol not found.</p>
          <button className="ipa-back" onClick={() => navigate("/study/ipa/symbols")}>← Back to Symbols</button>
        </div>
      <Footer /></>
    );
  }

  return (
    <>
      <Navbar />
      <div className="ipa-detail">
        <button className="ipa-back" onClick={() => navigate("/study/ipa/symbols")}>← Back to Symbols</button>

        <div className="ipa-detail-hero">
          <p className="ipa-detail-symbol">{symbol.symbol}</p>
          <p className="ipa-detail-name">{symbol.name}</p>
          <span className="ipa-detail-type">{symbol.type}</span>
          <span className="ipa-difficulty-badge" style={{ background: difficultyColor(symbol.difficulty) }}>
            {symbol.difficulty}
          </span>
        </div>

        {symbol.exampleWord && (
          <div className="ipa-card">
            <h3 className="ipa-card-title">💡 Example</h3>
            <p className="ipa-card-text">
              <strong>{symbol.exampleWord}</strong> — <em>{symbol.exampleIpa}</em>
            </p>
          </div>
        )}

        {symbol.description && (
          <div className="ipa-card">
            <h3 className="ipa-card-title">📝 How to Produce</h3>
            <p className="ipa-card-text">{symbol.description}</p>
          </div>
        )}

        {symbol.audioUrl && (
          <div className="ipa-card">
            <h3 className="ipa-card-title">🔊 Listen</h3>
            <audio ref={audioRef} src={symbol.audioUrl} preload="auto" />
            <button className="ipa-audio-btn" onClick={playAudio}>▶ Play Sound</button>
          </div>
        )}

        {symbol.mouthPositionImageUrl && (
          <div className="ipa-card">
            <h3 className="ipa-card-title">👄 Mouth Position</h3>
            <img className="ipa-mouth-img" src={symbol.mouthPositionImageUrl} alt={`Mouth position for ${symbol.symbol}`} />
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default IpaSymbolDetailPage;
